import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { If } from 'src/components/If';
import { FullPageSpinner } from 'src/components/Spinner';
import { useDecoratedPostHog } from 'src/providers/posthog';
import { ReactQueryParamsProvider } from 'src/providers/ReactQueryParamsProvider';
import { useAuth } from 'src/services/Auth';
import { useGlobalLoadingStore } from 'src/stores';
import { useUserGuiding } from 'src/lib/services/user-guiding';
import { WebViewAuthService } from 'src/services/Auth/WebView.auth';
import { useBrandsQuery } from 'src/api/queries';
import { useAuthStore } from 'src/services/Auth/Auth.store';


let tokenRefreshed = false;



const AuthLayout = () => {
  const { mount, dismount, refresh, isInitialLoading } = useAuth();
  const { isLoggedIn } = useAuthStore();
  const { isGlobalLoading, setGlobalLoading } = useGlobalLoadingStore();
  const brandsQuery = useBrandsQuery({}, { enabled: isLoggedIn });
  const postHog = useDecoratedPostHog();
  const location = useLocation();
  const userGuiding = useUserGuiding();

  const [currentLocation, setCurrentLocation] = useState(location.pathname);

  useEffect(() => {
    if (!tokenRefreshed) {
      refresh().then(() => setTimeout(() => setGlobalLoading(false), 500));

      tokenRefreshed = true;
    }

    mount();
    return () => {
      dismount();
    };
  }, []);

  useEffect(() => {
    if (currentLocation !== location.pathname) {
      // Commenting out postHog pageview due it constant barraging and hitting posthog limits
      // later will migrate to event specific capture
      // postHog.capture('$pageview');
      setCurrentLocation(location.pathname);
      userGuiding.pageCapture();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!isGlobalLoading && !isInitialLoading && WebViewAuthService.isWebViewAuthEnabled()) {
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          type: 'READY',
          secure: true,
        }),
      );
    }
  }, [isGlobalLoading || isInitialLoading]);

  return (
    <React.Fragment>
      <If
        when={
          (isGlobalLoading || isInitialLoading || (!brandsQuery?.data && isLoggedIn)) &&
          !WebViewAuthService.isWebViewAuthEnabled()
        }
        else={
          <ReactQueryParamsProvider>
            <Outlet />
          </ReactQueryParamsProvider>
        }
      >
        <FullPageSpinner />
      </If>
    </React.Fragment>
  );
};

export default AuthLayout;
